import { Page } from 'layouts/Page';
import { FC } from 'react';
import { HMRC } from 'components/HMRC';

export const HMRCPage: FC = () => {
	return (
		<Page title="HMRC – EAS Control Center">
			<HMRC />
		</Page>
	);
};
